<script>
  import { onDestroy } from 'svelte';
  import Track from '@utils/track';
  import { getCurrentUserStore } from '@stores/current_user';
  import Rating from '@utils/rating';
  import { getGroupStore } from '@stores/group';
  let groupStore = getGroupStore('groupStore');
  let recObjectsStore = getGroupStore('recObjectsStore');
  let configStore = getGroupStore('configStore');

  export let recObjectId;
  export let mobile = false;
  export let forceShowRating = false;
  export let recObjectRating = null;
  export let displayStyle = '';
  export let ratingWebResult;
  export let shown = false;
  export let customGroupStore;

  let recObject = recObjectId && recObjectsStore.find(recObjectId);
  let unsub = recObject && recObject.subscribe((x) => (recObject = x));
  let group = customGroupStore || groupStore;
  let currentUser = getCurrentUserStore('default');

  let config = configStore;
  let unsubConfig = configStore.subscribe((x) => (config = x));

  $: rating = recObjectRating
    ? recObjectRating
    : recObject && recObject.rec_ratings && recObject.rec_ratings.length > 0
      ? recObject.rec_ratings[0]
      : null;

  $: ratingConfig = Rating.configDataForRating(rating, config);

  let siteUrl = function () {
    return Rating.getRatingUrl(recObject, rating);
  };

  let setShown = function (node, value) {
    shown = value;
  };

  export let trackThenGoToRating = function () {
    window.open(siteUrl());
    Track.ratingClicked({
      user: currentUser,
      group,
      recObject,
      recRating: rating,
    });
  };

  onDestroy(() => {
    unsub && unsub();
    unsubConfig && unsubConfig();
  });
</script>

<style style="text/scss" lang="scss">
  .ui-rating-container {
    padding: 5px;

    .ui-rating {
      display: flex;
      justify-content: flex-end;
    }

    .ui-logo {
      display: flex;
      margin-top: 12px;
      justify-content: flex-end;
    }
  }

  .inline {
    a {
      display: flex;
      align-items: center;
      flex-direction: row-reverse;
      justify-content: flex-end;

      .ui-logo {
        margin-top: unset;
        margin-right: 15px;
      }
    }
  }
</style>

{#if Rating.shouldShowRating(recObject || ratingWebResult, rating, ratingConfig, forceShowRating)}
  {#key rating}
    <div use:setShown={true} class:mobile={mobile} class="ui-rating-container" class:inline={displayStyle === 'inline'}>
      <a
        on:click|preventDefault|stopPropagation={() => {
          trackThenGoToRating();
        }}
        href={siteUrl()}
        target="_blank">
        <div class="ui-rating">
          {@html Rating.convertToHtml(rating, ratingConfig, mobile)}
        </div>
        <div class="ui-logo">
          {@html Rating.convertLogoToHtml(rating, ratingConfig, mobile)}
        </div>
      </a>
    </div>
  {/key}
{:else}
  <div use:setShown={false} />
{/if}
